import gsap from "gsap";

export default class Header {
  constructor(el) {
    this.el = el;
    this.hamburger = null;
    this.mobileNav = null;
    this.navItems = null;
    this.searchIcon = null;
    this.searchBar = null;
    this.closeSearchButton = null;
    this.searchInput = null;
    this.init();
  }

  init() {
    this.hamburger = this.el.querySelector("[js-hamburger]");
    this.mobileNav = this.el.querySelector("#mobileNav");
    this.navItems = this.el.querySelectorAll("[js-nav-item]");
    this.searchIcon = document.querySelectorAll("[js-search-icon]");
    this.searchBar = document.querySelector("[js-search-bar]");
    this.closeSearchButton = document.querySelector(".close-search-bar");
    this.searchInput = document.querySelector("[js-search-input]");
    this.headerWrapper = document.querySelector(".full-header--wrapper");
    this.hamburger.addEventListener("click", () => this.toggleMobileNav());

    if (this.searchIcon.length > 0) {
      this.searchIcon.forEach((icon) => {
        icon.addEventListener("click", () => this.toggleSearchBar());
      });
    }

    this.makeHeaderSticky();
    this.createNavEventListeners();
    // this.handleResize();
    this.setupOutsideClickListener();
    this.setupCloseSearchListener();
  }

  toggleMobileNav() {
    const isOpen = this.hamburger.getAttribute("aria-expanded") === "true";
    isOpen ? this.closeMobileNav() : this.openMobileNav();
  }

  openMobileNav() {
    this.disableBtn(this.hamburger);
    this.hamburger.setAttribute("aria-expanded", true);
    this.mobileNav.classList.add("--expanded");
    this.el.classList.add("--menu-open");
    document.documentElement.classList.add("html-overflow-hidden");
  }

  closeMobileNav() {
    this.disableBtn(this.hamburger);
    this.hamburger.setAttribute("aria-expanded", false);
    this.mobileNav.classList.remove("--expanded");
    this.el.classList.remove("--menu-open");
    document.documentElement.classList.remove("html-overflow-hidden");
  }

  toggleSearchBar() {
    if (this.searchBar) {
      const isVisible = this.searchBar.classList.contains("is-visible");

      if (!isVisible) {
        gsap.set(this.searchBar, { css: { display: "block" } });
        gsap.to(this.searchBar, {
          opacity: 1,
          duration: 0.3,
          ease: "power3.out",
          onComplete: () => {
            this.searchInput.focus();
          },
        });
        this.searchBar.classList.add("is-visible");
        document.documentElement.classList.add("html-overflow-hidden");
      } else {
        this.closeSearchBar();
      }
    }
  }

  setupCloseSearchListener() {
    if (this.closeSearchButton) {
      this.closeSearchButton.addEventListener("click", () => this.closeSearchBar());
    }
  }

  setupOutsideClickListener() {
    document.addEventListener("click", (event) => {
      const isSearchBarVisible = this.searchBar.classList.contains("is-visible");
      // const isClickInsideSearchBar = this.searchBar.contains(event.target);
      const isClickOnSearchIcon = [...this.searchIcon].some((icon) => icon.contains(event.target));
      const isClickInsideSearchForm = this.searchBar.querySelector("form#searchform").contains(event.target);

      if (isSearchBarVisible && !isClickInsideSearchForm && !isClickOnSearchIcon) {
        this.closeSearchBar();
      }
    });
  }

  closeSearchBar() {
    gsap.to(this.searchBar, {
      opacity: 0,
      duration: 0.3,
      ease: "power3.out",
      onComplete: () => {
        gsap.set(this.searchBar, { css: { display: "none" } });
        this.searchBar.classList.remove("is-visible");
        document.documentElement.classList.remove("html-overflow-hidden");
      },
    });
  }

  disableBtn(btn) {
    btn.disabled = true;
    setTimeout(() => {
      btn.disabled = false;
    }, 500);
  }

  makeHeaderSticky() {
    let lastScrollY = window.scrollY || document.documentElement.scrollTop;

    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY || document.documentElement.scrollTop;

      if (currentScrollY > lastScrollY && currentScrollY > 0) {
        // Scrolling down: Hide header
        this.el.classList.add("--hidden");
        this.el.classList.remove("--sticky");
        this.el.classList.remove("--shadow");
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up: Show header with shadow
        this.el.classList.remove("--hidden");
        this.el.classList.add("--sticky");
        if (currentScrollY > 0) {
          this.el.classList.add("--shadow");
        } else {
          this.el.classList.remove("--shadow");
        }
      }

      lastScrollY = currentScrollY;
    });
  }

  createNavEventListeners() {
    this.navItems.forEach((el) => {
      const submenu = el.querySelector("[js-nav-item-submenu]");
      if (submenu) {
        el.addEventListener("mouseenter", () => this.onMouseEnter(submenu));
        el.addEventListener("mouseleave", () => this.onMouseLeave(submenu));
        const submenuItems = submenu.querySelectorAll("[js-nav-item-submenu-item]");

        submenuItems.forEach((item) => {
          const innermenu = item.querySelector("[js-nav-item-innermenu]");
          if (innermenu) {
            item.addEventListener("mouseenter", () => this.onMouseEnter(innermenu));
            item.addEventListener("mouseleave", () => this.onMouseLeave(innermenu));
          }
        });
      }
    });
  }

  onMouseEnter(submenu) {
    gsap.set(submenu, { css: { display: "block" } });
    gsap.to(submenu, {
      opacity: 1,
      duration: 0.2,
      ease: "power3.out",
    });
  }

  onMouseLeave(submenu) {
    gsap.to(submenu, {
      opacity: 0,
      duration: 0.2,
      ease: "power3.out",
    });
    gsap.set(submenu, { css: { display: "none" }, delay: 0.2 });
  }

  handleResize() {
    window.addEventListener("resize", () => {
      const isMobile = window.innerWidth < 768;
      const isOpen = this.hamburger.getAttribute("aria-expanded") === "true";
      if (!isMobile && isOpen) {
        this.closeMobileNav();
      }
    });
  }
}
